import React, { useState } from 'react';
import { IonPage, IonContent, IonInput, IonButton, IonItem, IonText } from '@ionic/react';
import { useRepositories } from '../../infrastructure/http/RepositoryProvider';
import BrandMark from '../components/BrandMark';
import './Login.css';

const ForgotPassword: React.FC = () => {
  const { auth } = useRepositories();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError(null);
    if (!email.trim()) {
      setError('Ingresá tu email.');
      return;
    }
    setLoading(true);
    try {
      await auth.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ocurrió un error.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage>
      <IonContent fullscreen className="login-content">
        <div className="login-container">
          <div className="login-logo">
            <BrandMark />
            <h1>DomIoT</h1>
            <p>Recuperar contraseña</p>
          </div>

          {sent ? (
            <IonText>
              <p style={{ textAlign: 'center', fontSize: 14, lineHeight: 1.6 }}>
                Si <strong>{email.trim()}</strong> tiene una cuenta con nosotros, te mandamos un email con
                instrucciones para elegir una nueva contraseña. Revisá también la carpeta de spam.
              </p>
            </IonText>
          ) : (
            <>
              <IonText>
                <p style={{ textAlign: 'center', fontSize: 14, color: 'var(--domiot-text-muted)' }}>
                  Ingresá el email de tu cuenta y te mandamos un enlace para restablecer tu contraseña.
                </p>
              </IonText>

              <IonItem>
                <IonInput
                  placeholder="Email"
                  type="email"
                  value={email}
                  onIonInput={(e) => setEmail(e.detail.value ?? '')}
                  onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                />
              </IonItem>

              {error && (
                <IonText color="danger">
                  <p className="login-error">{error}</p>
                </IonText>
              )}

              <IonButton expand="block" onClick={handleSubmit} disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar instrucciones'}
              </IonButton>
            </>
          )}

          <IonButton expand="block" fill="clear" routerLink="/login">
            Volver a iniciar sesión
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ForgotPassword;
